/**
 * DevExtreme (esm/ui/radio_group/radio_button.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import RadioButton from "../../__internal/ui/radio_group/m_radio_button";
export default RadioButton;
